import { memo } from 'react';
const SvgChevronRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="chevron-right_svg__feather chevron-right_svg__feather-chevron-right"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m9 18 6-6-6-6" />
  </svg>
);
const Memo = memo(SvgChevronRight);
export default Memo;
